module.exports = __webpack_public_path__ + "img/bucket.be5030ca.webp";